{
  "title": "Créer un nouveau compte",
  "selectAccount": "Sélectionner le type de compte",
  "accountHolder": "Titulaire du compte",
  "accountSummary": {
    "added": "Vous avez correctement ajouté un nouveau compte",
    "failed": "Échec de l'ajout d'un nouveau compte.",
    "subAccMsg": "Relions ce compte à un sous-compte"
  },
  "actions": {
    "createNewAccount": "Créer un nouveau compte",
    "createSubAccount": "Créer un sous-compte"
  },
  "govFundOptions": {
    "ADDITIONAL_CESG": "SCEE supplémentaire",
    "BASIC_CESG": "Subvention canadienne pour l’épargne-études",
    "CLB": "Bon d'études canadien"
  },
  "isTransferredFromAnotherInstitution": "Transféré d'un autre établissement",
  "yes": "Oui",
  "no": "Non",
  "sourceOfFundsOptions": {
    "SELF": "Personnel",
    "SPOUSE": "Époux",
    "USA_EMPLOYMENT_WAGES": " Salaires de l'emploi",
    "USA_INHERITANCE_TRUST": " Héritage/Fiducie",
    "USA_LOTTERY_GAMING": "Loterie/Jeux",
    "USA_RETIREMENT_FUNDS": "Fonds de retrait",
    "USA_INVESTMENTS": "Investissements",
    "USA_SPOUSAL_PARENTAL_SUPPORT": "Aide du conjoint/parent",
    "USA_GIFT": "Cadeau",
    "USA_SAVINGS": "Économies",
    "USA_UNEMPLOYMENT_DISABILITY": " Chômage/Handicap",
    "USA_LEGAL_SETTLEMENT": "Règlement judiciaire",
    "USA_OTHER": "Autre"
  },
  "sourceOfFunds": "Sources des fonds",
  "jurisdiction": "Territoire",
  "custodianAccountNumber": "Numéro de compte du bénéficiaire",
  "feeGridTitle": "Grille tarifaire",
  "billingCycleTitle": "Cycle de facturation",
  "householdClientGroup": "Famille",
  "federal": "Fédéral",
  "messages": {
    "setUpSubAccount": "Configurons ensuite votre sous-compte",
    "requireAffiliate": "Ce type de compte nécessite au moins un affilié"
  },
  "outlineText": {
    "skipForSubAccount": "Ignorer pour le moment et créer le sous-compte",
    "skipNow": "Ignorer pour le moment"
  },
  "repCode": "Code de représentant"
}
